import * as h2Api from '../h2Api'
import * as educatorActions from '../actions/educator'

const initialState = {}

export default (state = initialState, action) => {
  switch (action.type) {
    case educatorActions.LOAD_TENANT_INFO:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        console.log('Found', action)

        return {
          ...state,
          ...action.restCall.result
        }
      }

      return state
    default:
      return state
  }
}
